/**
 * Get Writer Poll
 * @param {string} storyId
 * @param {string} partId
 * @returns {poll: object} - Returns the writer poll object
 */

const clientAPICall = url => {
    return Promise.resolve(
      $.ajax({
        type: "GET",
        url: url,
        xhrFields: {
          withCredentials: true
        },
      })
    );
  };
  
  module.exports = function(storyId, partId) {
    return new Promise(function(resolve, reject) {
      const url = `${wattpad?.apiDomain}/writing/v1/stories/${storyId}/parts/${partId}/polls`;
  
      clientAPICall(url)
        .then(poll => {
          return resolve(poll);
        })
        .catch(err => {
          return reject(err);
        });
    });
  };
  